import React from 'react'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useWindowSize } from 'src/app/hooks'
import styles from './WithdrawalFilterResetButton.module.scss'
import { setWithdrawalsFilterStatus, setWithdrawalsFilterText } from 'src/features'

const WithdrawalFilterResetButton: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { width } = useWindowSize()
  const isMobile = width <= 800

  const handleResetFilter = () => {
    dispatch(setWithdrawalsFilterText(null))
    dispatch(setWithdrawalsFilterStatus('pending'))
    showNotification('info', t('Validate.FilterReseted'))
  }

  return (
    <Button
      type='text'
      size={'middle'}
      className={isMobile ? styles.mobileView : styles.resetButton}
      onClick={handleResetFilter}
      block={isMobile}
    >
      {t('Validate.Reset')}
    </Button>
  )
}

export default WithdrawalFilterResetButton
